export default {
  messages: {
    required: () => 'Campo obrigatório'
  },

  custom: {
    company_document_number: {
      min: 'Campo CNPJ deve conter ao menos 14 caracteres'
    },

    company_phone: {
      min: 'Campo deve conter no mínimo 10 caracteres'
    },

    name: {
      alpha_spaces: 'Campo nome deve conter apenas caracteres alfabéticos e espaços.',
      min: 'Campo nome completo deve conter ao menos 2 caracteres'
    },

    full_name: {
      alpha_spaces: 'Campo nome completo deve conter apenas caracteres alfabéticos e espaços.',
      min: 'Campo nome completo deve conter ao menos 2 caracteres'
    },

    email: {
      email: 'E-mail inválido'
    },

    additional_email: {
      email: 'E-mail inválido'
    },

    document_number: {
      min: 'CPF deve conter 11 caracteres'
    },

    birth_date: {
      min: 'Data de nascimento inválida'
    },

    phone: {
      min: 'Campo telefone deve conter no mínimo 10 caracteres'
    },

    mobile_phone: {
      min: 'Campo celular deve conter no mínimo 10 caracteres'
    },

    zip_code: {
      min: 'Campo CEP deve conter no mínimo 8 caracteres'
    },

    password1: {
      required: 'Campo senha é obrigatório',
      min: 'A senha deve conter no mínimo 8 caracteres',
      regex: 'A senha não deve ser totalmente numérica.'
    },

    password2: {
      required: 'Campo confirmar senha é obrigatório',
      min: 'A senha deve conter no mínimo 8 caracteres',
      regex: 'A senha não deve ser totalmente numérica.',
      confirmed: 'As senhas não conferem'
    },

    guest_name: {
      min: 'Campo nome do convidado deve conter ao menos 2 caracteres',
      alpha_spaces: 'O campo nome do convidado deve conter apenas caracteres alfabéticos e espaços.'
    },

    guest_email: {
      min: 'A senha deve conter no mínimo 8 caracteres'
    }
  }
}
